import ProBlogPost from './ProBlogPost';
import type { ProBlogPostProps } from './ProBlogPost';

export type { ProBlogPostProps };
export default ProBlogPost;
